export * from "./Bom2aPositionsTable";
